module.exports = __webpack_public_path__ + "static/media/NinerLogo.f0b6cb50.webp";